// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState, useEffect } from 'react'

const DISMISSED_KEY = 'casavio_install_dismissed'
const DISMISS_DAYS = 7

export default function InstallPrompt() {
  const [show, setShow] = useState(false)
  const [isIOS, setIsIOS] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState(null)

  useEffect(() => {
    // Already installed as standalone — never show
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return

    // Dismissed recently — don't show
    const dismissed = localStorage.getItem(DISMISSED_KEY)
    if (dismissed && Date.now() - parseInt(dismissed) < DISMISS_DAYS * 24 * 60 * 60 * 1000) return

    const ua = navigator.userAgent.toLowerCase()
    const ios = /iphone|ipad|ipod/.test(ua)
    const safari = /safari/.test(ua) && !/chrome|crios|fxios/.test(ua)

    if (ios && safari) {
      // iOS Safari: show manual instructions after a short delay
      const t = setTimeout(() => { setIsIOS(true); setShow(true) }, 2000)
      return () => clearTimeout(t)
    }

    // Android / Chrome: wait for browser's install event
    const handler = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setShow(true)
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const handleInstall = async () => {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    setDeferredPrompt(null)
    if (outcome === 'accepted') setShow(false)
  }

  const handleDismiss = () => {
    setShow(false)
    localStorage.setItem(DISMISSED_KEY, Date.now().toString())
  }

  if (!show) return null

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9000,
      background: '#2C1D14', color: '#FDFAF6',
      padding: '14px 20px',
      paddingBottom: 'max(14px, calc(14px + env(safe-area-inset-bottom, 0px)))',
      display: 'flex', alignItems: 'center', gap: '12px',
      boxShadow: '0 -4px 24px rgba(44,29,20,0.35)',
      fontFamily: 'Georgia, serif',
      animation: 'slideUp 0.3s ease',
    }}>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      <div style={{ fontSize: '26px', flexShrink: 0 }}>🏠</div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '14px', fontWeight: '700', marginBottom: '3px' }}>
          Add Casavio to your home screen
        </div>
        {isIOS ? (
          <div style={{ fontSize: '12px', color: 'rgba(253,250,246,0.7)', fontFamily: 'Calibri, sans-serif', lineHeight: 1.4 }}>
            Tap <span style={{ color: '#D4902A', fontWeight: '700' }}>Share ↑</span> then{' '}
            <span style={{ color: '#D4902A', fontWeight: '700' }}>Add to Home Screen</span>
          </div>
        ) : (
          <div style={{ fontSize: '12px', color: 'rgba(253,250,246,0.7)', fontFamily: 'Calibri, sans-serif' }}>
            Install for faster access, offline support, and a native app feel
          </div>
        )}
      </div>

      {!isIOS && deferredPrompt && (
        <button
          onClick={handleInstall}
          style={{
            background: 'linear-gradient(135deg, #B8721F, #D4902A)',
            border: 'none', borderRadius: '8px', padding: '9px 16px',
            fontSize: '12px', color: '#FDFAF6', fontWeight: '700',
            cursor: 'pointer', fontFamily: 'Georgia, serif',
            letterSpacing: '1px', whiteSpace: 'nowrap', flexShrink: 0,
          }}
        >
          Install
        </button>
      )}

      <button
        onClick={handleDismiss}
        style={{
          background: 'none', border: 'none',
          color: 'rgba(253,250,246,0.5)', fontSize: '22px',
          cursor: 'pointer', padding: '2px 4px', lineHeight: 1, flexShrink: 0,
        }}
      >×</button>
    </div>
  )
}
